import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="m11.996 7.224 1.843-1.843a3.384 3.384 0 0 1 4.78 4.78l-2.639 2.63-.002.002a3.364 3.364 0 0 1-4.769 0 .75.75 0 0 0-1.062 1.058 4.866 4.866 0 0 0 6.893.001l2.652-2.642.025-.027a4.885 4.885 0 0 0-6.925-6.876l-1.857 1.856a.75.75 0 0 0 1.06 1.061" />
    <path d="M9.115 10.475a3.37 3.37 0 0 1 3.675.732.75.75 0 1 0 1.063-1.058 4.865 4.865 0 0 0-6.893-.001L4.308 12.79l-.025.026a4.884 4.884 0 0 0 6.925 6.876l1.857-1.856a.75.75 0 1 0-1.061-1.061l-1.843 1.843a3.384 3.384 0 0 1-4.78-4.78l2.639-2.63.002-.002a3.4 3.4 0 0 1 1.093-.732" />
  </>
);

const Link = Icon('link', svgContents);

export default Link;
